<template>
    <div class="cep-modal">
        <h2>{{ getString("informe_cep") }}</h2>

        <div class="input-container">
            <label for="cep">{{ getString("cep") }}</label>
            <div
                id="cep"
                ref="cepDiv"
                class="div-input-android"
                :class="{ 'active-input': isTheActiveInput('cepDiv') }"
                @click="switchActiveInput('cepDiv')">
            </div>

            <span v-if="cepError" class="error-message"> {{ getString("cep_invalido") }}</span>

            <div v-if="checkcpf">

                <div class="field-wrapper">
                    <div class="field-wrapper">
                        <label for="name">{{ getString('razao_social') }}</label>
                        <div
                            id="fantasia"
                            ref="fantasiaDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('fantasiaDiv'), 'error-input': fantasiaError}"
                            @click="switchActiveInput('fantasiaDiv')">
                        </div>
                        <span v-if="fantasiaError" class="error-message">{{ getString('razao_social_obrigatorio') }}</span>
                    </div>

                    <div class="field-wrapper">
                        <label for="registro_estado">{{ getString('registro_estado') }}</label>

                        <div
                            id="registro_estado"
                            ref="registroEstadoDiv"
                            class="div-input-android select-field"
                            :class="{
                                'active-input': isTheActiveInput('registroEstadoDiv'),
                                'error-input': registroEstadoError
                            }"
                            @click="toggleRegistroEstadoOptions"
                        >
                            {{ selectedRegistroEstado || 'Selecione uma opção' }}
                        </div>

                        <span v-if="registroEstadoError" class="error-message">
                            {{ getString('registro_estado_obrigatorio') }}
                        </span>

                        <!-- DROPDOWN CORRETO -->
                        <div v-if="showRegistroEstadoOptions" class="options-dropdown">
                            <div
                                v-for="option in registroEstadoOptions"
                                :key="option"
                                class="option-item"
                                @click="selectRegistroEstado(option)"
                            >
                                {{ option }}
                            </div>
                        </div>
                    </div>

                <div class="address-field">
                    <div class="field-wrapper">
                        <label for="estado">{{ getString("UF") }}</label>
                        <div
                        id="estado"
                        ref="estadoDiv"
                        class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('estadoDiv'), 'error-input': estadoError }"
                        @click="switchActiveInput('estadoDiv')">
                        </div>
                        <span v-if="estadoError" class="error-message"></span>
                    </div>

                    <div class="field-wrapper">
                        <label for="cidade">{{ getString("cidade") }}</label>
                        <div
                            id="cidade"
                            ref="cidadeDiv"
                            class="div-input-android"
                            :class="{ 'active-input': isTheActiveInput('cidadeDiv'), 'error-input': cidadeError }"
                            @click="switchActiveInput('cidadeDiv')">
                        </div>
                        <span v-if="cidadeError" class="error-message"></span>
                    </div>
                </div>

                    <label for="bairro">{{ getString("bairro") }}</label>
                    <div
                        id="bairro"
                        ref="bairroDiv"
                        class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('bairroDiv') }"
                        @click="switchActiveInput('bairroDiv')">
                    </div>

                <label for="rua">{{ getString("rua") }}</label>
                <div
                    id="rua"
                    ref="ruaDiv"
                    class="div-input-android"
                    :class="{ 'active-input': isTheActiveInput('ruaDiv'), 'error-input': ruaError }"
                    @click="switchActiveInput('ruaDiv')">
                </div>
                <span v-if="ruaError" class="error-message"></span>

                <div class="address-field">
                    <div class="field-wrapper">
                        <label for="numero">{{ getString("numero") }}</label>
                            <div
                                id="numero"
                                ref="numeroDiv"
                                class="div-input-android"
                                :class="{ 'active-input': isTheActiveInput('numeroDiv'), 'error-input': numeroError }"
                                @click="switchActiveInput('numeroDiv')">
                            </div>
                        <span v-if="numeroError" class="error-message"></span>
                    </div>

                <div class="field-wrapper">
                    <label for="complemento">{{ getString("complemento") }}</label>
                    <div
                        id="complemento"
                        ref="complementoDiv"
                        class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('complementoDiv') }"
                        @click="switchActiveInput('complementoDiv')">
                    </div>
                </div>
                </div>
            </div>
        </div>

        <AndroidKeyboard
            id="android-keyboard"
            :inputElement="inputElement"
            :layout="layout"
            :isPasswordField="false"
            :onInput="handleInput"
            :maxCaracteres="getMaxCaracteres()">
        </AndroidKeyboard>

        <div class="buttons-container">
            <DefaultButton
                :text="getString('cancelar')"
                @defaultBtnClick="cancel"
                class="buttons">
            </DefaultButton>

            <DefaultButton
                :text="getString('confirmar')"
                @defaultBtnClick="confirm"
                class="buttons"
                :disabled="!confirmed">
            </DefaultButton>
        </div>

    </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton.vue'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import LocaleController from '@/assets/controllers/LocaleController'
import axios from 'axios'

export default {
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            checkcpf: true,
            selectedRegistroEstado: '',
            rawCepValue: '',
            numeroError: false,
            cepError: false,
            ruaError: false,
            fantasiaError: false,
            registroEstadoError: false,
            estadoError: false,
            cidadeError: false,
            confirmed: false,
            showRegistroEstadoOptions: false,
            registroEstadoOptions: [
                'ISENTO',
                'INSCRIÇÃO NUMÉRICA',
                'NULO OU NÃO CONTRIBUINTE'
            ],
            buttons: [
                {
                    text: this.getString('cancelar'),
                    action: this.cancel
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm
                }
            ]
        }
    },
    mounted () {
        this.inputElement = this.$refs.cepDiv
        this.switchActiveInput('cepDiv')
    },
    methods: {
        getString (key) {
            return LocaleController.getString(key)
        },
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput: function (divReference) {
            const newInput = this.$refs[divReference]

            if (newInput && this.inputElement !== newInput) {
                const currentContent = newInput.textContent
                this.inputElement = newInput

                this.$nextTick(() => {
                    if (newInput.textContent === '' && currentContent !== '') {
                        newInput.textContent = currentContent
                    }
                })
            }
        },
        getMaxCaracteres: function () {
            if (this.inputElement === this.$refs.cepDiv) {
                return 9
            }
            return null
        },
        handleInput: function (value) {
            const errorMap = {
                numeroDiv: 'numeroError',
                ruaDiv: 'ruaError',
                fantasiaDiv: 'fantasiaError',
                estadoDiv: 'estadoError',
                cidadeDiv: 'cidadeError',
                cepDiv: 'cepError'
            }

            for (const [ref, errorProp] of Object.entries(errorMap)) {
                if (this.inputElement === this.$refs[ref]) {
                    this[errorProp] = false
                    break
                }
            }

            if (this.inputElement === this.$refs.cepDiv) {
                this.cepError = false
                const onlyNumbers = value.replace(/\D/g, '')
                this.rawCepValue = onlyNumbers.slice(0, 8)

                if (this.$refs.cepDiv.textContent.length === 9) {
                    this.findCep(this.rawCepValue)
                } else {
                    this.confirmed = false
                }

                if (this.rawCepValue.length > 5) {
                    return this.rawCepValue.slice(0, 5) + '-' + this.rawCepValue.slice(5)
                }
                return this.rawCepValue
            }
            return value
        },
        formatCep: function (value) {
            // Formata CEP: 12345-678
            const onlyNumbers = value.replace(/\D/g, '').slice(0, 8)

            if (onlyNumbers.length > 5) {
                this.findCep(onlyNumbers)
                return onlyNumbers.slice(0, 5) + '-' + onlyNumbers.slice(5)
            }
            return onlyNumbers
        },
        toggleRegistroEstadoOptions () {
            this.showRegistroEstadoOptions = !this.showRegistroEstadoOptions
        },

        selectRegistroEstado (option) {
            this.selectedRegistroEstado = option
            this.$refs.registroEstadoDiv.textContent = option
            this.showRegistroEstadoOptions = false
            this.registroEstadoError = false
        },
        getRefValue: function (refName) {
            return this.$refs[refName] && this.$refs[refName].textContent ? this.$refs[refName].textContent.trim() : ''
        },
        cancel: function () {
            this.$emit('close')
        },
        confirm: function () {
            if (this.hasError()) {
                return
            }

            const addressData = {
                fantasia: this.getRefValue('fantasiaDiv'),
                registroEstado: this.selectedRegistroEstado,
                cep: this.rawCepValue,
                estado: this.getRefValue('estadoDiv'),
                cidade: this.getRefValue('cidadeDiv'),
                bairro: this.getRefValue('bairroDiv'),
                rua: this.getRefValue('ruaDiv'),
                numero: this.getRefValue('numeroDiv'),
                complemento: this.getRefValue('complementoDiv')
            }

            this.$emit('address', addressData)
        },
        hasError: function () {
            this.cepError = false
            this.fantasiaError = false
            this.registroEstadoError = false
            this.estadoError = false
            this.cidadeError = false
            this.ruaError = false
            this.numeroError = false

            let hasError = false

            if (this.rawCepValue.length < 8 || this.$refs.cepDiv.textContent.length !== 9 || !this.confirmed) {
                this.cepError = true
                hasError = true
            }

            const requiredFields = [
                { ref: 'fantasiaDiv', error: 'fantasiaError' },
                { ref: 'estadoDiv', error: 'estadoError' },
                { ref: 'cidadeDiv', error: 'cidadeError' },
                { ref: 'ruaDiv', error: 'ruaError' },
                { ref: 'numeroDiv', error: 'numeroError' }
            ]

            for (const field of requiredFields) {
                if (this.getRefValue(field.ref) === '') {
                    this[field.error] = true
                    hasError = true
                }
            }

            if (this.selectedRegistroEstado === '') {
                this.registroEstadoError = true
                hasError = true
            }

            return hasError
        },
        async findCep (cep) {
            const sanitizedCep = cep.replace(/\D/g, '')

            if (sanitizedCep.length === 8) {
                try {
                    const response = await axios.get(`https://viacep.com.br/ws/${sanitizedCep}/json/`)
                    const data = response.data

                    if (data.erro) {
                        this.confirmed = false
                        this.cepError = true
                        throw new Error('CEP inválido')
                    }

                    if (this.$refs.estadoDiv) {
                        this.$refs.estadoDiv.textContent = data.uf
                    }
                    if (this.$refs.cidadeDiv) {
                        this.$refs.cidadeDiv.textContent = data.localidade
                    }
                    if (this.$refs.bairroDiv) {
                        this.$refs.bairroDiv.textContent = data.bairro
                    }
                    if (this.$refs.ruaDiv) {
                        this.$refs.ruaDiv.textContent = data.logradouro
                    }

                    this.confirmed = true
                    return data
                } catch (error) {
                    this.cepError = true
                    this.confirmed = false
                    console.error('Erro ao buscar CEP:', error)
                    return null
                }
            }
            return null
        }
    }
}
</script>

<style scoped lang="less">
@import (reference) url("../assets/common.less");

//variáveis de estilo
@input-height: 60px;
@input-font: 3rem;
@input-radius: 22px;
@mobile-font: 1.3rem;
@mobile-height: 40px;

.div-input-android {
    height: @input-height;
    padding: 0 12px;
    border: 2px solid @black;
    border-radius: @input-radius;
    display: flex;
    align-items: center;
    font-size: @input-font;
    background: @white;
    color: @black;
    transition: all .18s ease;
}

.div-input-android.active-input {
    border-width: 3px;
    border-color: @primary-color;
}

.field-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 12px 0;
}

label {
    font-size: @input-font;
    margin-bottom: 6px;
    font-weight: bold;
}

.cep-modal {
    z-index: 9999;
    position: fixed;
    width: 90%;
    max-width: 750px;
    max-height: 90vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    background-color: @white;
    border-radius: @input-radius;
    overflow-y: auto;

    h2 {
        font-size: 40px;
        text-align: center;
        margin-bottom: 22px;
        color: @primary-color;
    }
    .error-input {
        border: 3px solid #ff0000 !important;
    }

    .error-message {
        color: #ff0000;
        font-size: @input-font;
        display: block;
        // margin-bottom: 10px;
    }

    .input-container {
        margin: 20px 0;

        label {
            font-size: @input-font;
        }

        .select-field {
            cursor: pointer;
            user-select: none;
        }

        .options-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            width: 90%;
            background-color: white;
            border: 2px solid @black;
            border-radius: 4px;
            margin-top: 5px;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

            .option-item {
                padding: 15px 20px;
                cursor: pointer;
                font-size: 1.5rem;
                border-bottom: 1px solid #e0e0e0;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background-color: #f5f5f5;
                }

                &:active {
                    background-color: @primary-color;
                    color: white;
                }
            }
        }

        .address-field {
            display: flex;
            gap: 6px;
            align-items: flex-end;
            justify-content: space-between;
            // margin-bottom: 10px;

            > div {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
        }
    }

    .buttons-container {
        display: flex;
        justify-content: space-around;
        padding: 20px 0;

        .buttons {
            flex: 1;
            margin: 0 10px;
        }

        button:first-of-type {
            background: @white;
            border: 1px@black @black;
            color: @black;
        }
    }
}

.div-input-android.error {
    border-color: red !important;
}

/* telas pequenas */
@media (max-width: 550px) {
    .div-input-android {
        height: @mobile-height;
        font-size: 0.9rem !important;
        border-radius: 12px;
        padding: 0 10px;
    }

    label{
        font-size: 0.9rem !important;
    }

    .error-message{
        font-size: 0.9rem !important;
    }

    .cep-modal {
        padding: 20px;
        max-width: 420px;

        .field-wrapper {
            margin: 0px 0;
        }

        .input-container{
            .options-dropdown{
                .option-item {
                    padding: 10px 10px !important;
                    font-size: 0.9rem !important;
                }
            }
        }

        h2 {
            font-size: 22px !important;
            margin-bottom: 12px;
        }

        .input-container label {
            font-size: 0.9rem !important;
        }
    }
}

/* super pequenas */
@media (max-width: 500px) and (max-height: 600px) {
    .div-input-android {
        height: 36px;
        font-size: 1.15rem !important;
        padding: 0 8px;
    }

    label {
        font-size: 1.2rem !important;
    }

    .error-message{
        font-size: 1rem !important;
    }

    .cep-modal {
        padding: 16px;
        max-width: 380px;

        h2 {
            font-size: 18px !important;
        }

        .field-wrapper {
            margin: 0px 0;
        }

        .buttons-container button {
            padding: 8px;
            font-size: 1.2rem !important;
        }
    }
}

/* telas médias */
@media (max-width: 698px) {
    .cep-modal h2 {
        font-size: 22px !important;
    }

}

@media (min-width: 699px) and (max-width: 1025px) {
    .div-input-android {
        height: 40px;
        font-size: 1.5rem !important;
        border-radius: 14px;
        padding: 0 10px;
    }

    .field-wrapper {
        margin: 6px 0;
    }

    .input-container{
            .options-dropdown{
                .option-item {
                    padding: 15px 15px !important;
                    font-size: 1.5rem !important;
                }
            }
    }

    .cep-modal h2 {
        font-size: 32px !important;
    }
    label {
        font-size: 1.5rem !important;
    }
    .error-message{
        font-size: 1.5rem !important;
    }
}

/* 1024x768 */
@media (width: 1024px) and (height: 768px) {

    .cep-modal {
        padding: 22px;
        width: 72%;
        max-height: 82vh;
        border-radius: 18px;
    }

    .cep-modal h2 {
        font-size: 28px !important;
        margin-bottom: 14px;
    }

    .div-input-android {
        height: 40px;
        font-size: 1.1rem !important;
        border-radius: 14px;
        padding: 0 10px;
    }

    label {
        font-size: 1.2rem !important;
        margin-bottom: 2px;
    }

    .field-wrapper {
        margin: 6px 0;
    }

    .input-container .address-field {
        gap: 6px;
        margin-bottom: 6px;
    }

    .input-container{
            .options-dropdown{
                .option-item {
                    padding: 10 px 15px !important;
                    font-size: 1.2rem !important;
                }
            }
    }

    .buttons-container button {
        padding: 8px 10px;
        font-size: 1.3rem !important;
        border-radius: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CepModal.vue